(() => {
  const dialog = document.getElementById('AbsenRegionDialog');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const country = form.elements.country_code;
  const language = form.elements.language_code;
  const cards = [...dialog.querySelectorAll('[data-region-country]')];
  const recommended = dialog.querySelector('[data-region-recommended] span');
  const search = dialog.querySelector('[data-absen-region-search]');
  let opener;
  const updateSelection = (useDefault = false) => {
    const selected = cards.find(card => card.dataset.regionCountry === country.value);
    const defaultOption = [...language.options].find(option => option.value === selected?.dataset.regionDefault);
    cards.forEach(card => card.setAttribute('aria-pressed', String(card === selected)));
    if (useDefault && defaultOption) language.value = defaultOption.value;
    recommended.textContent = defaultOption?.textContent || '';
    recommended.parentElement.hidden = !defaultOption;
  };
  country.addEventListener('change', () => updateSelection(true));
  cards.forEach(card => card.addEventListener('click', () => {
    country.value = card.dataset.regionCountry;
    updateSelection(true);
    if (matchMedia('(max-width: 749px)').matches) form.querySelector('.absen-region-dialog__selection').scrollIntoView({ block: 'nearest' });
  }));
  search.addEventListener('input', () => {
    const query = search.value.trim().toLocaleLowerCase();
    cards.forEach(card => { card.hidden = !card.dataset.regionSearch.toLocaleLowerCase().includes(query); });
    dialog.querySelectorAll('[data-region-group]').forEach(group => { group.hidden = !group.querySelector('[data-region-country]:not([hidden])'); });
    dialog.querySelector('[data-region-empty]').hidden = cards.some(card => !card.hidden);
  });
  document.querySelectorAll('[data-absen-region-open]').forEach(trigger => trigger.addEventListener('click', event => {
    if (!dialog.showModal) return;
    event.preventDefault();
    const drawer = trigger.closest('header-drawer');
    opener = drawer?.querySelector('summary') || trigger;
    drawer?.querySelector('[on\\:click="/close"]')?.click();
    updateSelection();
    dialog.showModal();
    if (!matchMedia('(max-width: 749px)').matches) search.focus({ preventScroll: true });
  }));
  dialog.querySelector('[data-absen-region-close]').addEventListener('click', event => { event.preventDefault(); dialog.close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  if (location.hash === '#AbsenRegionDialog' && dialog.showModal) {
    history.replaceState(history.state, '', location.pathname + location.search);
    dialog.showModal();
  }
  const returnTo = form.elements.return_to;
  if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  updateSelection();
})();
